import React from "react";
import PropTypes from "prop-types";
import StyledDropDownRadio from "./DropDownRadioEverscore.styled";

const DropDownRadio = React.memo(props => {
  const { range, checked, value,name, getId, onChange } = props;
  return (
    <StyledDropDownRadio className={`dropdown-sort__radio ${checked && "is-checked"}`}>
      <input  checked={checked} value={value} onChange={onChange} onClick={(e) => getId(e)} aria-label={name} id={range.id}   type="radio" />
      <span className="dropdown-sort__radio__custom"/>
      <span className="dropdown-sort__radio__copy">{range.name}</span>
    </StyledDropDownRadio>
  );
});

DropDownRadio.propTypes = {
  range: PropTypes.object.isRequired,
  checked: PropTypes.bool.isRequired
};

export default DropDownRadio;